import axios, {AxiosError} from 'axios'
import {API_URL} from '../../../../_metronic/helpers'
import {
  CompanySettings,
  CompanySettingsUpdate,
  NotificationApiError,
  NotificationList,
  NotificationListFilter,
  NotificationSettings,
  NotificationSummary,
  UserSettingsUpdate,
} from './models'

const BASE_URL = `${API_URL}/notifications`

export const readNotificationError = (error: unknown, fallback: string): NotificationApiError => {
  if (
    error instanceof Error &&
    'code' in error &&
    (error as NotificationApiError).status !== undefined
  ) {
    return error as NotificationApiError
  }
  const axiosError = error as AxiosError<{code?: string; message?: string; Message?: string}>
  const data = axiosError.response?.data
  const message =
    data?.message ||
    data?.Message ||
    (!axiosError.response ? 'ارتباط با سرور برقرار نشد. اتصال اینترنت را بررسی کنید.' : fallback)
  const result = new Error(message) as NotificationApiError
  result.code = data?.code
  result.status = axiosError.response?.status
  return result
}

export const getNotificationSummary = async () =>
  (await axios.get<NotificationSummary>(`${BASE_URL}/summary`)).data

export const listNotifications = async (filter: NotificationListFilter) =>
  (
    await axios.get<NotificationList>(BASE_URL, {
      params: {
        page: filter.page,
        pageSize: filter.pageSize,
        unreadOnly: filter.unreadOnly || undefined,
        companyId: filter.companyId || undefined,
        group: filter.group || undefined,
      },
    })
  ).data

export const markNotificationsRead = async (ids: number[]) =>
  (await axios.post<{updated: number}>(`${BASE_URL}/read`, {ids})).data

export const markAllNotificationsRead = async () =>
  (await axios.post<{updated: number}>(`${BASE_URL}/read-all`, {})).data

export const getNotificationSettings = async (companyId?: number | null) =>
  (
    await axios.get<NotificationSettings>(`${BASE_URL}/settings`, {
      params: {companyId: companyId || undefined},
    })
  ).data

export const updateNotificationSettings = async (value: UserSettingsUpdate) =>
  (await axios.put<NotificationSettings>(`${BASE_URL}/settings`, value)).data

export const updateCompanyNotificationSettings = async (value: CompanySettingsUpdate) =>
  (await axios.put<CompanySettings>(`${BASE_URL}/company-settings`, value)).data

export const sendTestNotification = async (channel: 'inapp' | 'sms' | 'telegram' | 'push') =>
  (await axios.post<{notificationId: number; deliveries: number}>(`${BASE_URL}/test`, {channel}))
    .data
